//LIBRARIES
import React, { Fragment } from 'react';
import styled from 'styled-components';

//HELPERS
import { getTranslatedString } from 'helpers/i18n';

//COMPONENTS
import Spacer from 'components/ui/Spacer';
import TextBox from 'components/ui/TextBox';
import Form from 'components/ui/Form';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import ReactPhoneInput from 'components/shared/ReactPhoneInput';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';

const Title = styled.p`
  font-size: 18px;
  font-weight: bold;
`;

const PersonalDetails = ({ values, errors, setFieldValue, handleChange, isUserAdmin }) => {
  return (
    <Fragment>
      <Spacer mb={1}>
        <Title>Resident Details</Title>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={`${getTranslatedString('showingDrawer.firstName')}*`}
              validateStatus={errors.first_name ? 'error' : null}
              help={errors.first_name}
            >
              <TextBox
                name="first_name"
                value={values.first_name}
                onChange={handleChange}
                placeholder="e.g. John"
                disabled={hostIsCapreit()}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={`${getTranslatedString('showingDrawer.lastName')}*`}
              validateStatus={errors.last_name ? 'error' : null}
              help={errors.last_name}
            >
              <TextBox
                name="last_name"
                value={values.last_name}
                onChange={handleChange}
                placeholder="e.g. Doe"
                disabled={hostIsCapreit()}
                size="large"
              />
            </Form.Item>
          </Col>
        </Row>
      </Spacer>
      <Spacer mb={1}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={`${getTranslatedString('showingDrawer.email')}*`}
              validateStatus={errors.email ? 'error' : null}
              help={errors.email}
            >
              <TextBox
                name="email"
                value={values.email}
                onChange={handleChange}
                placeholder="e.g. johndoe@gmail.com"
                size="large"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={`${getTranslatedString('showingDrawer.phoneNumber')}*`}
              validateStatus={errors.phone_number ? 'error' : null}
              help={errors.phone_number}
            >
              <ReactPhoneInput
                value={values.phone_number}
                onChange={value => setFieldValue('phone_number', value)}
                hasError={errors.phone_number}
              />
            </Form.Item>
          </Col>
        </Row>
      </Spacer>
    </Fragment>
  );
};

export default PersonalDetails;
